export default "__VITE_ASSET__6031a34f__"